import React from "react";
import RichText from "components/rich-text";
import Image from "components/image";

const ImageText = ({ data }) => (
    <div className={` z-30 relative`}>
        <div className={`image-text bg-zinc-50 ${data?.alternate ? "flex-col-reverse lg:flex-row-reverse" : "flex-col lg:flex-row"}`}>
            <div className="w-full lg:w-[55%] py-2.5 lg:py-0 px-4">
                <Image image={data?.image} alt={data.image.alt} width={620} className="h-80 rounded" />
            </div>
            <div className="w-full lg:w-[45%] py-2.5 lg:py-0 px-4 font-normal">
                <RichText value={data?.content} />
            </div>
        </div>
    </div>
);

export default ImageText;
